import { render, staticRenderFns } from "./OxygenSpacingInput.vue?vue&type=template&id=719d3638&"
import script from "./OxygenSpacingInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenSpacingInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenSpacingInput.vue?vue&type=style&index=0&id=719d3638&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports